import { render, staticRenderFns } from "./NewsDetailOverlay.vue?vue&type=template&id=1130a280&scoped=true"
import script from "./NewsDetailOverlay.vue?vue&type=script&lang=js"
export * from "./NewsDetailOverlay.vue?vue&type=script&lang=js"
import style0 from "./NewsDetailOverlay.vue?vue&type=style&index=0&id=1130a280&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1130a280",
  null
  
)

export default component.exports